import { colors } from '../../colors';
var para = {
  messageColor: colors.pinkishRed
};
export default para;